import React, {useState} from 'react';

const AddMovie = () =>{

  return (
    <div>
      <h1>Add a Movie in System</h1>
     
     
    </div>
  );
}
export default AddMovie;